export class SceneCardsController {
	static init() {
		document.addEventListener("DOMContentLoaded", () => {
			const elements = document.getElementsByClassName(
				"design_video_container"
			) as HTMLCollectionOf<HTMLElement>;
			for (let i = 0; i < elements.length; i++) {
				const element = elements[i];

				// const current_display = element.style.display;
				// if (current_display == "none") {
				// then we are on desktop
				this.init_element_for_desktop(element);
				// } else {
				// nothing to do since the VideoVisibilityChecker should handle it
				// }
			}
		});
	}

	static init_element_for_desktop(element: HTMLElement) {
		const video = element.querySelector("video");
		if (video) {
			element.addEventListener("mouseenter", () => {
				video.play();
			});
			element.addEventListener("mouseleave", () => {
				video.pause();
			});
		}
	}
}
